window.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isNew = urlParams.get('new');

  if (isNew === '1') {
    const target = document.querySelector('product-info .shopify-app-block');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
window.addEventListener('cloudlift.upload.ready', function(e) {
  console.log ( 'upload lift ready',  );
});
window.addEventListener('upload:added',async function(e) {
  var file = e.detail;
  console.debug('file added', file);
  if(file.url && file.meta.variant === 'thumbnail'){
    console.log('file is thumbnail!');
  }

  uploadedFile = file.url;
  console.log('new file: ' + file.url);

  if ( file.url != '' ) {
    const addToCartForm = $( `product-form form[data-type="add-to-cart-form"] .customAdd2Cart` ).closest( `form` );
    const isPropertiesEle = addToCartForm.find( `form-properties` ).length;
    if ( isPropertiesEle == 0 ) {
      addToCartForm.append( `
        <form-properties>
          <input type="hidden" name="properties[Upload (Vector Files Preferred)]" value="${ file.url }">
        </form-properties>
      ` );
    }
  }
  console.log ( 'upload done' );
});
window.addEventListener('upload:removed', function(e) {
  let file = e.detail;
  $( `form-properties` ).remove();
  uploadedFile = '';
});

function addFilesAsProperties() {
  try {
    location.href = '?new=1';
  } catch ( err ) {
    console.log( `ERROR addFilesAsProperties()`, err.message );
  }
}
